import React, { Component } from "react";
import {
  Navbar,
  Progress,
  Nav,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardLink,
  CardTitle,
  CardSubtitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";

class MainSearchForm extends Component {
  render() {
    const {
      roleValue,
      onRoleChange,
      locationValue,
      handleLocationChange,
      daysValue,
      handleDaysChange,
      selectedOptionId,
      onSubmit
    } = this.props;
    return (
      <Form inline onSubmit={onSubmit}>
        <Col md={4}>
          <FormGroup>
            <Label for="exampleEmail" className="from-label">
              ROLE TYPE / KEYWORDS
            </Label>
            <Input
              type="text"
              value={roleValue}
              onChange={onRoleChange}
              placeholder="Role Title or Keywords"
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label for="Location" className="from-label">
              LOCATION
            </Label>
            <Input
              type="text"
              className="form-control"
              value={locationValue}
              onChange={handleLocationChange}
              placeholder="City, Town or County"
            />
          </FormGroup>
        </Col>
        <Col md={2}>
          <FormGroup>
            <Label for="days" className="from-label">
              DATE POSTED
            </Label>
            <Input
              type="select"
              onChange={handleDaysChange}
              value={daysValue}
              //defaultValue={selectedOptionId}
              name="select"
              id="exampleSelect"
            >
              <option value="1">1 Day Ago</option>
              <option value="3">3 Days Ago</option>
              <option value="7">7 Days Ago</option>
              <option value="14">14 Days Ago</option>
              <option value="28">28 Days Ago</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={2}>
          <Button className="search-Btn">SEARCH</Button>
        </Col>
      </Form>
    );
  }
}

export default MainSearchForm;
